import { render, staticRenderFns } from "./oncallRules.vue?vue&type=template&id=1dcefa5f&"
import script from "./oncallRules.vue?vue&type=script&lang=ts&"
export * from "./oncallRules.vue?vue&type=script&lang=ts&"
import style0 from "./oncallRules.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports